import { Footer } from '@/previewThemes/emeraude/Footer';
import { Header } from '@/previewThemes/emeraude/Header';
import { Product } from '@/previewThemes/emeraude/Product';
import {
  emeraudeProductParts,
  emeraudeProductSections,
} from '@/previewThemes/emeraude/productPage';
import type { ThemePackage } from '@/previewThemes/types';

export const theme: ThemePackage = {
  Header,
  Footer,
  Product,
  listing: {
    // Three across beside the filter rail: a jewellery tile is a small object
    // on a lot of ground, and at four columns the piece itself gets too small
    // to judge.
    grid: 'grid-cols-2 gap-6 lg:grid-cols-3',
    filters: 'sidebar',
    columns: 3,
    // The jeweller's case: every piece in a thin frame on the pale ground.
    card: 'framed',
  },
  cart: { grid: 'mt-10 grid gap-10 lg:grid-cols-3', panel: 'outlined' },
  checkout: {
    grid: 'mt-10 grid items-start gap-10 lg:grid-cols-[minmax(0,1fr)_24rem] lg:gap-14',
    panel: 'outlined',
  },
  search: {
    grid: 'mt-10 grid gap-10 lg:grid-cols-[260px_1fr]',
    results: 'grid grid-cols-2 gap-6 lg:grid-cols-3',
    columns: 3,
    card: 'framed',
    // The facet rail sits in a filled panel, so the filters read as one block
    // beside the results rather than a loose column of checkboxes.
    panel: 'filled',
  },
  // The journal in two wide columns: each post is led by a large photograph.
  blog: { list: 'grid gap-10 sm:grid-cols-2', title: 'text-2xl' },
  // Collections four across, the name centred under each picture.
  category: { grid: 'grid gap-6 sm:grid-cols-2 lg:grid-cols-4', tile: 'bare' },
  pages: {
    product: { defaults: emeraudeProductSections },
  },
  parts: {
    product_details: {
      defaults: emeraudeProductParts,
      presentation: {
        classes: {
          product_brand: 'text-[12px] uppercase tracking-[0.18em]',
          product_title: 'text-4xl sm:text-5xl leading-tight',
          product_price: 'text-2xl',
          product_short_description: 'text-[14px]',
        },
        wideButtons: true,
        gallery: { aspect: 'square', thumbs: 'below' },
      },
    },
  },
};
